import { render, staticRenderFns } from "./chooseQuestionUpdate.vue?vue&type=template&id=a71dea90&"
import script from "./chooseQuestionUpdate.vue?vue&type=script&lang=js&"
export * from "./chooseQuestionUpdate.vue?vue&type=script&lang=js&"
import style0 from "./chooseQuestionUpdate.vue?vue&type=style&index=0&id=a71dea90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports